import { SET_WIDGET_INFO } from '../actions/types';

export default function widgetInfo(state = {}, action) {
	if (!action.error && action.payload) {
		if (action.type && action.type === SET_WIDGET_INFO) {
			const {
				payload: { pageAlias, accountId }
			} = action;
			return {
				pageAlias,
				accountId
			};
		}
	}

	return state;
}
